"use client";

import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function SpecializedRecruitmentSolutionBlockTwo() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.3,
    once: true
  });
  return <section className="bg-page-background py-16 px-6 sm:px-8 lg:px-12">
      <div className="mx-auto max-w-4xl">
        <div ref={ref} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`}>
          <Card className="card shadow-strong hover:shadow-strong hover:-translate-y-1">
            <CardHeader>
              <CardTitle className="text-2xl sm:text-3xl text-foreground font-display">
                Tailored Recruitment Solutions
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-foreground leading-relaxed">Activate delivers specialised and bespoke management recruitment solutions designed to meet your unique hiring challenges. Our platform streamlines the recruitment process, connecting you with top talent efficiently and effectively. Experience the benefits of a dedicated partner committed to your success.</p>
            </CardContent>
            <CardFooter>
              <Link to="/ContactUsPage">
                <Button variant="default" size="lg" className="btn-primary focus-ring group">
                  Get Started
                  <ArrowRight className="transition-transform duration-[var(--duration-fast)] group-hover:translate-x-1" />
                </Button>
              </Link>
            </CardFooter>
          </Card>
        </div>
      </div>
    </section>;
}